import React from 'react';
import { FieldError } from 'react-hook-form';
import { FieldConfig } from './props';

interface DynamicContactFormRowProps {
  fieldKey: string
  fieldConfig: FieldConfig
  error?: FieldError
  getErrorMessage: (fieldKey: string) => string | undefined
  hasError: (fieldKey: string) => FieldError | undefined
  children: React.ReactNode
}

const DynamicContactFormRow: React.FC<DynamicContactFormRowProps> = ({
  fieldKey,
  fieldConfig,
  getErrorMessage,
  hasError,
  children
}) => (
  <div className={`dynamic-form__row dynamic-form__row_${fieldKey}`}>
    <label className={`dynamic-form__label dynamic-form__label_${fieldKey}`} htmlFor={fieldKey}>
      {fieldConfig.label}:
    </label>
    {children}
    {hasError(fieldKey) && (
      <div className={`dynamic-form__alert dynamic-form__alert_${fieldKey}`}>
        {getErrorMessage(fieldKey) || fieldConfig.defaultMessage}
      </div>
    )}
  </div>
);

export default DynamicContactFormRow; 